import { getNewsMediaPulseTracker } from "..";

const trackViewStrawberryPartnerPage = (id: string, name: string) => {
  const newsMediaPulseTracker = getNewsMediaPulseTracker();

  newsMediaPulseTracker?.executeNewsMediaPulseCommand("trackViewPage", {
    object: {
      pageId: id,
      name,
    },
  });
};

export { trackViewStrawberryPartnerPage };
